'use strict';

bbw.directive.bbwChecklist = ['$rootScope', function($rootScope) {

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: true,
        transclude: true,
        template: '<ng-transclude></ng-transclude>',
        controller: function() {
            // pass
        },
        controllerAs: 'bbwChecklistCtrl',
        link: function(scope, element, attrs, ngModel) {
            scope.bbwChecklistCtrl.ngModel = ngModel;
            scope.bbwChecklistCtrl.set = function(key, checked) {
                var modelValue = angular.isArray(ngModel.$modelValue) ? angular.copy(ngModel.$modelValue) : [];
                var idx = modelValue.indexOf(key);
                if (checked != (idx >= 0)) {
                    if (checked) {
                        modelValue.push(key);
                    } else {
                        modelValue.splice(idx, 1);
                    }
                    ngModel.$setViewValue(modelValue);
                    ngModel.$setDirty();
                    ngModel.$setTouched();
                }
            };
            ngModel.$render = function() {
                if (!scope.bbwChecklistCtrl.value) {
                    ngModel.$setPristine();
                }
                scope.bbwChecklistCtrl.value = ngModel.$viewValue;
            };
        }
    };

}];

bbw.directive.bbwChecklistItem = ['$rootScope', function($rootScope) {

    return {
        restrict: 'A',
        require: '^bbwChecklist',
        scope: {
            item: '=bbwChecklistItem'
        },
        link: function(scope, element, attrs, bbwChecklist) {
            scope.bbwChecklist = bbwChecklist;
            var initialized = false;
            scope.$watchCollection('bbwChecklist.value', function(newValue, oldValue) {
                var isChecked = angular.isArray(newValue) && newValue.indexOf(scope.item) >= 0;
                var needChange = false;
                if (!initialized) {
                    initialized = true;
                    needChange = true;
                } else {
                    var wasChecked = angular.isArray(oldValue) ? oldValue.indexOf(scope.item) >= 0 : false;
                    needChange = isChecked != wasChecked;
                }
                if (needChange) {
                    if (isChecked) {
                        element[0].setAttribute('checked', 'checked');
                    } else {
                        element[0].removeAttribute('checked');
                    }
                }
            });
            element.on('change', function() {
                bbwChecklist.set(scope.item, !!element[0].checked);
            });
        }
    };

}];

bbw.directive.bbwChecklistRequired = [function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$validators.bbwChecklistRequired = function(value) {
                return angular.isArray(value) && value.length > 0;
            };
        }
    };
}];
